import React from 'react';

import { Alert, Box } from '@mui/material';

export const WarningBanner = () => {
  return (
    <Box component="span" m={1}>
      <Alert severity="warning">
        [Warning] Underwriting engine is now paused due to technical issues!
        Automated evidences ordering may be affected.
      </Alert>
    </Box>
  );
};
